import React from "react";
import ReactDOM from "react-dom/client";
import { App as AntApp, ConfigProvider } from "antd";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { brand } from "@deltabeacon/config";
import { AuthProvider } from "./auth";
import { RootApp } from "./App";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 10_000, retry: 1, refetchOnWindowFocus: true },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: brand.colors.blue,
          colorInfo: brand.colors.blue,
          colorSuccess: brand.colors.up,
          colorError: brand.colors.down,
          colorText: brand.colors.ink,
          colorTextSecondary: brand.colors.muted,
          colorBorderSecondary: brand.colors.line,
          borderRadius: 10,
          borderRadiusLG: 16,
          fontFamily:
            'Manrope, -apple-system, BlinkMacSystemFont, "PingFang SC", sans-serif',
        },
        components: {
          Layout: {
            bodyBg: brand.colors.canvas,
            siderBg: brand.colors.ink,
            headerBg: brand.colors.surface,
          },
          Table: { headerBg: "#F2F7FB", rowHoverBg: "#F5F9FD" },
          Card: { headerBg: "transparent" },
        },
      }}
    >
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <RootApp />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>,
);
